import { NetworkStatus } from "@apollo/client";

const getLoadingFromNetworkStatus = (networkStatus: NetworkStatus) =>
    networkStatus === NetworkStatus.loading;

export default getLoadingFromNetworkStatus;
